<div class="app-body animated fadeIn m-0">
  <!-- <div class="row justify-content-start m-0 py-3" style="width:100%;">
       <div class="col-lg-12 col-md-12 col-sm-12 login-new-details px-5">
           <div class="logo-org">
               <h3 class="logo-text"><img src="/assets/img/brand/Astute1.jpg"  style="width:40px;"/>  Astute Corporate Services Pvt Ltd</h3>
           </div>
       </div>
   </div> -->
    <!-- <div class="row justify-content-start mx-0 mt-4" style="width:100%;">
      <div class="col-lg-4 col-md-6 col-sm-9 col-12 login-new-details px-5 mt-3">
            <h3 class="title">Login</h3>
            <p class="subline-text"><small>Enter your details to get sign in to your account</small></p>
            <form #loginForm="ngForm" (ngSubmit)="login()">
              <p style="color: tomato;">{{errorMsg}}</p>
                <label class="form-group has-top-label mb-4">
                    <input class="form-control" type="text" name="Lid" placeholder="Login Id" [(ngModel)]="model.employeeid" required>
                    <span class="text-label">Login ID</span>
                    <i class="fa fas fa-user" aria-hidden="true"></i>
                    <p style="color: tomato; font-size:11px;">{{errorEmployeeid}}</p>
                </label>

                <label class="form-group has-top-label mb-4">
                  <input class="form-control" [type]="inputType" name="pw" placeholder="Password" [(ngModel)]="model.password" required>
                  <span class="text-label">Password</span>
                 <i class="fa" [ngClass]="{'fa-eye': !showPassword, 'fa-eye-slash': showPassword}" aria-hidden="true" (click)="passwordVisiblity()"></i>
                 <p style="color: tomato; font-size:11px;">{{errorPassword}}</p>
                </label>

                <div class="form-group mt-1">
                  <button type="submit" class="btn py-3 btn-block login-btn" [disabled]="showLoader || !model.employeeid || !model.password">
                    Sign in
                    <img class="loader-img" src="assets/img/loader/ajax-loader.gif"  style="width:20px;" *ngIf="showLoader"/>
                  </button> 
                </div>


            </form>
      </div>
    </div> -->

<!-- login.component.html -->
<div class="login-wrapper">

   <!-- left Panel: Login Form -->
  <div class="form-panel">
    <div class="form-card">

      <!-- Logo -->
      <div class="logo-wrap">
        <div class="logo-icon">
          <!-- <svg viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg" width="44" height="44">
            <rect width="48" height="48" rx="12" fill="#1a3a5c"/>
            <path d="M10 36L18 12H24L32 36H26L24.5 31H17.5L16 36H10Z" fill="#f0b429"/>
            <path d="M17.5 31H24.5L21 20L17.5 31Z" fill="white" opacity="0.3"/>
            <path d="M33 14H38V36H33V14Z" fill="#f0b429"/>
            <path d="M28 14H38V18H28V14Z" fill="#f0b429"/>
          </svg> -->
          <img src="/assets/img/brand/Astute1.jpg" alt="Astute Logo" style="width:40px;"/>
        </div>
        <div class="logo-text">
          <span class="logo-brand">Astute</span>
          <span class="logo-product">ITR</span>
        </div>
      </div>

      <p class="form-tagline">Document Verification Portal</p>

      <!-- Divider -->
      <div class="form-divider">
        <span class="divider-line"></span>
        <span class="divider-text">Sign in to continue</span>
        <span class="divider-line"></span>
      </div>

      <!-- Form -->
     <form class="login-form" #loginForm="ngForm" (ngSubmit)="login(loginForm)" novalidate>

        <div class="field-group">
          <label class="field-label">User ID</label>
          <div class="input-wrap" [class.input-error]="userId.invalid && userId.touched">
            <span class="input-icon">
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
                <circle cx="12" cy="7" r="4" />
              </svg>
            </span>
            <input 
              class="field-input" 
              type="text" 
              name="Lid" 
              placeholder="Login Id" 
              [(ngModel)]="model.employeeid" 
              #userId="ngModel"
              required />
          </div>
          <p class="error-text" *ngIf="userId.invalid && userId.touched" style="color:#d73131; font-size:11px; ">User ID is required</p>
        </div>

        <div class="field-group">
          <label class="field-label">Password</label>
          <div class="input-wrap" [class.input-error]="pw.invalid && pw.touched">
            <span class="input-icon">
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <rect x="3" y="11" width="18" height="11" rx="2" ry="2" />
                <path d="M7 11V7a5 5 0 0 1 10 0v4" />
              </svg>
            </span>
            <input 
              class="field-input" 
              [type]="showPassword ? 'text' : 'password'" 
              name="pw" 
              placeholder="Password" 
              [(ngModel)]="model.password" 
              #pw="ngModel"
              required 
              minlength="4" />
            
            <button type="button" class="eye-btn" (click)="showPassword = !showPassword" tabindex="-1">
              <svg *ngIf="!showPassword" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/><circle cx="12" cy="12" r="3"/>
              </svg>
              <svg *ngIf="showPassword" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24"/><line x1="1" y1="1" x2="23" y2="23"/>
              </svg>
            </button>
          </div>
          <p class="error-text" *ngIf="pw.invalid && pw.touched">
            <span *ngIf="pw.errors?.['required']" style="color:#d73131; font-size:11px; ">Password is required</span>
            <span *ngIf="pw.errors?.['minlength']" style="color:#d73131; font-size:11px; ">Too short (min 4 chars)</span>
          </p>
        </div>

        <div class="error-banner" *ngIf="errorMsg">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/>
          </svg>
          <span style="color:#d73131; font-size:11px; ">{{errorMsg}}</span>
        </div>

        <button type="submit" class="submit-btn" [disabled]="showLoader || loginForm.invalid">
          <span class="btn-content" *ngIf="!showLoader">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" class="btn-icon">
              <path d="M15 3h4a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2h-4"/>
              <polyline points="10 17 15 12 10 7"/>
              <line x1="15" y1="12" x2="3" y2="12"/>
            </svg>
            Sign In to Portal  
          </span>
          <span class="btn-spinner" *ngIf="showLoader">
            <span class="spinner-ring"></span>
            Authenticating...
          </span>
        </button>

    </form>

      <!-- Footer note -->
      <div class="secure-note">
        <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <rect x="3" y="11" width="18" height="11" rx="2"/>
          <path d="M7 11V7a5 5 0 0 1 10 0v4"/>
        </svg>
        All data is confidential
      </div>

    </div>

    <div class="form-footer-copy">
      &copy; 2026 Astute Corporation Pvt. Ltd. &nbsp;·&nbsp;
      <!-- <a href="javascript:void(0)">Privacy Policy</a> &nbsp;·&nbsp; <a href="javascript:void(0)">Support</a> -->
    </div>
  </div>

  <!-- right Panel: Branding / Visual -->
  <div class="brand-panel">
    <div class="brand-overlay"></div>
    <div class="floating-docs">
      <div class="doc-card doc-card--1">
        <span class="doc-icon">📄</span>
        <span class="doc-label">Form-26AS</span>
      </div>
      <div class="doc-card doc-card--2">
        <span class="doc-icon">🧾</span>
        <span class="doc-label">Physical-ITR</span>
      </div>
      <div class="doc-card doc-card--3">
        <span class="doc-icon">✅</span>
        <span class="doc-label">Verified</span>
      </div>
      <div class="doc-card doc-card--4">
        <span class="doc-icon">📊</span>
        <span class="doc-label">Financial-ITR</span>
      </div>
    </div>

    <div class="brand-content">
      <div class="brand-badge">INCOME TAX RETURNS</div>
      <h1 class="brand-headline">
        <span class="headline-line headline-line--1">Verify.</span><br>
        <span class="headline-line headline-line--2">Compare.</span><br>
        <span class="headline-line headline-line--3">Comply.</span>
      </h1>
      <p class="brand-sub">
        Intelligent document verification and comparison
        for accurate ITR filing — powered by Astute Corporation.
      </p>
      <div class="trust-row">
        <div class="trust-item"><span class="trust-num">100%</span><span class="trust-desc">Secure</span></div>
        <div class="trust-divider"></div>
        <div class="trust-item"><span class="trust-num">AI</span><span class="trust-desc">Verified</span></div>
        <div class="trust-divider"></div>
        <div class="trust-item"><span class="trust-num">GST</span><span class="trust-desc">Compliant</span></div>
      </div>
    </div>

    <!-- Decorative grid lines -->
    <div class="grid-lines">
      <div class="gl gl-h gl-h1"></div>
      <div class="gl gl-h gl-h2"></div>
      <div class="gl gl-v gl-v1"></div>
      <div class="gl gl-v gl-v2"></div>
    </div>
  </div>

 

</div>



  </div>

